import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getAuthoringScheduleGroups = api(async function getAuthoringScheduleGroups() {
    return query(
        gql`
            query GetAuthoringScheduleGroups {
                getAuthoringScheduleGroups {
                    id
                    name
                    path
                    parentId
                    typeId
                }
            }
        `,
        {},
        { returns: "getAuthoringScheduleGroups" }
    )
})
